var map = {
	"./clock-in.svg": 83065,
	"./company-icon-01.svg": 19946,
	"./company-icon-02.svg": 11321,
	"./company-icon-03.svg": 45928,
	"./company-icon-04.svg": 18759,
	"./company-icon-05.svg": 54934,
	"./company-icon-06.svg": 43157,
	"./company-icon-07.svg": 70548,
	"./company-icon-08.svg": 3683,
	"./company-icon-09.svg": 89042,
	"./company-icon-10.svg": 33048,
	"./delete.svg": 4738,
	"./edit.svg": 96415,
	"./eye.svg": 59850,
	"./google-icon.svg": 68648,
	"./holiday-calendar.svg": 24608,
	"./icon-01.svg": 77320,
	"./icon-02.svg": 58683,
	"./icon-03.svg": 16714,
	"./icon-04.svg": 71989,
	"./icon-05.svg": 27060,
	"./profile-upload-img.svg": 39726,
	"./tag-user-icon.svg": 7631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;